import React, { Component } from 'react';
import './Recommendations.css';
import '../../components/onboarding/StickyHeader.css';
import { recommendationsProductTypeInfo } from "../../utils/util";

class Product_categoryHolder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productType: this.props.productType ? this.props.productType.toLowerCase().replace(/\s*/g,"") : ''
        };
    }


    render() {
        return (
            <div className="recomments-productType-area">
                <div className="productType-title h4-title">{this.props.productType}</div>
                <div className="productType-conten navy">{ recommendationsProductTypeInfo(this.props.skinTypeOneWord, this.state.productType  )}</div>
            </div>
        )
    }
}

export default Product_categoryHolder;



// WEBPACK FOOTER //
// ./src/views/recommendations/Recommendations_categoryHolder.js